<template>
    <div v-wechat-title="ckPatient.title">
        <el-row>
            <item-input
                style="width: 300px;text-align: center;"
                type="string"
                class="margin5 margin-none-h"
                v-model="searchKey2"
                :autofocus="true"
                :placeholder="getPlaceholder"
                :clearable="true"
                @keyup.native.enter="checkPatient"
            ></item-input>
        </el-row>
        <el-row v-show="checkPass>0" style="font-weight: bold; color: black;">
            <span>
                核查结果
            </span>
            <el-col :span="24">
                <span v-if="checkPass == 1 && surgeryInfo" style="color: green;height: 400px; text-align: left;">
                    <el-row>
                        患者：{{surgeryInfo.visit_info.name}}[{{surgeryInfo.visit_info.his_id || '--'}}]
                    </el-row>
                    <el-row>
                        术前诊断：{{surgeryInfo.plan_diseases.map(d => d.label).join(',')}}
                    </el-row>
                    <el-row>
                        手术名称：{{surgeryInfo.plan_surgeries.map(d => d.label).join(',')}}
                    </el-row>
                    <el-row>
                        核对人：{{checkInfo}}
                    </el-row>
                </span>
                <span v-if="checkPass == 2" style="color: red;height: 100px;">注意：此患者和手术患者不是同一人!</span>
            </el-col>
        </el-row>
        <div style="bottom: 20px; right: 20px; position: fixed;">
            <el-button type="primary" @click="confirm">确 定</el-button>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `AnesthsiaCheckPatient`,
    props: {

    },
    data() {
        return {
            usergroup: [],
            surgeryId: this.$route.query.surgery_id,
            recordType: this.$route.query.recordType,
            token: this.$route.query.token,
            searchKey: ``,
            searchKey2: ``,
            surgerSubStringRule: ``,
            surgeryInfo: null,
            checkInfo: ``,
            ckPatient: {
                dialogFormVisible: true,
                data: {},
                title: `核对患者`
            },
            checkPass: 0
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.loadSurgerSubStringRule().then(() => {
            this.loadSurgery()
        })
    },
    computed: {
        ...mapGetters([`screenHeight`, `currentUser`]),
        getPlaceholder() {
            return `请扫${this.T(`anesthesia_surgery_list.visit_no`)}`
        }
    },
    mounted() {
    },
    methods: {
        confirm() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: ``,
                    action: `closeWindow`
                }
                winformMsg.acceptMessage(cefJson)
            }
        },
        loadSurgerSubStringRule() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=SurgerSubStringRule`)
                req.then(data => {
                    if (data) {
                        this.surgerSubStringRule = data.value && data.value.trim()
                    }
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        checkPatient() {
            let that = this
            this.searchKey = this.substringcdata(this.searchKey2)
            let sk = that.searchKey.toUpperCase()
            if (sk.length > 0) {
                var visitInfo = that.surgeryInfo && that.surgeryInfo.visit_info
                if (visitInfo && (visitInfo.visit_no.toUpperCase() == sk || visitInfo.his_id == sk)) {
                    console.log(`核对成功`)
                    let req = that.myaxios.post(`/api/Preoperative/Apply/SetCheckSurgery?surgeryId=${that.surgeryId}`)
                    req.then(data => {
                        if (data) {
                            that.checkInfo = data
                        }
                    }).catch(e => console.log(e))
                    that.checkPass = 1
                } else {
                    that.checkPass = 2
                }
            } else {
                that.checkPass = 0
            }
        },
        substringcdata(inputval) {
            let outval = ``
            if (this.surgerSubStringRule != ``) {
                let rulestr = this.surgerSubStringRule.split(`,`)
                let left = rulestr[0]
                let right = rulestr[1]
                if (left == 0 && right != 0) {
                    outval = inputval.substring(0, right)
                } else if (left != 0 && right != 0) {
                    outval = inputval.substring(left, right)
                } else {
                    outval = inputval
                }
            } else {
                outval = inputval
            }
            return outval
        },
        loadSurgery() {
            let that = this
            if (!that.surgeryId) return
            let req = that.myaxios.get(`/api/Preoperative/Apply/Get/${that.surgeryId}`)
            req.then(data => {
                if (data) {
                    that.surgeryInfo = data
                    console.log(that.surgeryInfo)
                }
            }).catch(e => console.log(e))
        }
    },
    watch: {
    }
}
</script>
<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/AnesthsiaCheckPatient.vue